/* eslint-disable import/prefer-default-export */
export const getLabelProps = (colors) => ({
  notOpen: {
    title: 'Not Open',
    color: colors.mediumBlue,
    background: colors.backgrounds.default,
    tooltipText: 'The assignment will accept submissions when it opens.',
  },
  nearDueDate: {
    title: 'Open',
    color: colors.green,
    background: colors.backgrounds.primary,
    tooltipText: 'The assignment is open for submissions.',
  },
  open: {
    title: 'Open',
    color: colors.black,
    background: colors.backgrounds.primary,
    tooltipText: 'The assignment is open for submissions.',
  },
  pastDueDate: {
    title: 'Past due date',
    color: colors.black,
    background: colors.backgrounds.warning,
    tooltipText:
      'The due date is past but the assignment is still open for submissions.',
  },
  closed: {
    title: 'Closed',
    color: colors.purple,
    background: colors.backgrounds.secondary,
    tooltipText:
      'The assignment is closed and does not accept submissions at this point.',
  },
  submitted: {
    title: 'Submitted',
    color: colors.green,
    background: colors.backgrounds.primary,
    tooltipText: 'Submitted',
  },
  submittedLate: {
    title: 'Submitted Late',
    color: colors.orange,
    background: colors.backgrounds.warning,
    tooltipText: 'Submitted Late',
  },
  notSubmitted: {
    title: 'Not Submitted',
    color: colors.mediumBlue,
    background: colors.backgrounds.default,
    tooltipText: 'Not Submitted',
  },
  manualAssignment: {
    title: 'Manual assignment',
    color: colors.mediumBlue,
    background: colors.backgrounds.default,
  },
});
